
import Vue from "vue";
import AppContainer from "@/components/login/LoginContainer.vue";
import AppSection from "@/components/login/LoginSection.vue";
import AppText from "@/components/login/LoginText.vue";
import AppError from "@/components/common/ErrorMessageBox.vue";
import { AuthService } from "../services/auth-service";
import { HttpError } from "../utils/services/http-error";

export default Vue.extend({
	data(){
		return {
			complete: false,
			error: ""
		};
	},
	methods: {
		async doTransfer(){
			try{
				await AuthService.confirmChangeEmail(this.$route.params.token);
				this.complete = true;
			}catch(err){
				let e = err as HttpError;
				e.dontShow = true;
				this.error = e.getText();
			}
		}
	},
	mounted(){
		let splashEl = document.getElementById("splash");
		if (splashEl){
			splashEl.remove();
		}
		this.doTransfer();
	},
	components: {
		AppContainer,
		AppSection,
		AppText,
		AppError
	},
	i18nEx: {
		componentPrefix: "views.AccountEmailTransfer"
	}
});
